import React from "react";
import SelectField from "../../../../Forms/Input/SelectField";

interface Option {
  id: number;
  name: string;
}

interface Props {
  name: string;
  label: string;
  value: string | number;
  options: Option[];
  onChange: (value: string) => void;
}

const SelectFilterField: React.FC<Props> = ({
  name,
  label,
  value,
  options,
  onChange,
}) => {
  return (
    <SelectField
      label={label}
      name={name}
      value={value}
      onChange={(event) => {
        const val = event?.target?.value;
        if (val !== undefined) {
          onChange(String(val));
        }
      }}
      options={options.map((opt) => ({
        label: opt.name,
        value: opt.id,
      }))}
      placeholder="Seleccione"
      iconKey="list"
    />
  );
};

export default SelectFilterField;
